import { FC, useMemo } from "react";

import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

import { LinkCell } from "@/common/DataGridCells";
import ManagementListLayout from "@/components/feedback/components/ManagementListLayout";
import { FEEDBACK_COLLECTION_FIXTURES } from "@/components/feedback/data/feedbackCollectionFixtures";

interface SurveyRow {
  id: string;
  name: string;
}

const SurveysPage: FC = () => {
  const navigate = useNavigate();

  const rows = useMemo<SurveyRow[]>(
    () =>
      FEEDBACK_COLLECTION_FIXTURES.map((collection) => ({
        id: collection.id,
        name: collection.name,
      })),
    [],
  );

  const columns: GridColDef<SurveyRow>[] = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 240,
      renderCell: ({ value, row }) => (
        <LinkCell value={value} onClick={() => navigate(row.id)} />
      ),
    },
    { field: "id", headerName: "ID", width: 320 },
  ];

  return (
    <ManagementListLayout
      title="Surveys"
      actionLabel="Create Survey"
      onAction={() => navigate("new")}
    >
      <DataGrid<SurveyRow>
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        disableRowSelectionOnClick
        pageSizeOptions={[25, 50, 100]}
      />
    </ManagementListLayout>
  );
};

export default SurveysPage;
